import { t } from "i18next";

export const getUserId = (user) => user.EmployesId ?? user.EmployeId;

export const getFullName = (user) =>
	[user.FirstName, user.LastName?.toUpperCase()].filter((a) => a).join(" ");

// Label of an export field, in the user language (the CSV headers use it too)
export const fieldLabel = (field) => t("Contacts.EXPORT_FIELD_" + field.id, { defaultValue: field.title });

// Same labels as the contacts table
export function roleLabel(role) {
	if (!role)
		return ("");
	if (["SiteAdmin", "SuperAdmin"].includes(role))
		return (t("Contacts.ADMIN_ROLE"));
	if (role === "EloAdmin")
		return (t("Contacts.ELOADMIN"));
	return (t("Contacts.USER_ROLE"));
}

// Same format as the contacts table: "Name - Town"
export function siteLabel(site) {
	if (!site)
		return ("");
	const name = site.Name?.trim() || "";
	const town = site.Town?.trim();
	return (name + (town ? " - " + town : ""));
}

/*
** The filtered contacts request (Employes/FilteredSortedContactEmployesWithGroup) returns
** "WFY": null and "WFU": null. The unfiltered one of the company has them: it is loaded once
** (cached) to complete the contacts by id.
** TODO: remove when the API returns WFY / WFU in the filtered request.
*/
const PROFESSIONS_STALE_TIME = 5 * 60 * 1000;
const FIRST_PAGE_SIZE = 1000;

// Query of all the company contacts (with WFY / WFU), shared by the table (useQuery) and the CSV (fetchQuery)
export function professionsQuery(genRequest, companyId) {
	const url = (pageSize) =>
		`Employes/SortedContactEmployesWithGroupOfCompany?CompanyId=${companyId}&PageNumber=1&PageSize=${pageSize}`;

	return ({
		queryKey: ["Employes", "ExportProfessions", companyId],
		queryFn: async () => {
			// One call is enough for most companies; a second one only if there are more contacts
			const first = await genRequest(url(FIRST_PAGE_SIZE));
			const items = first?.Items || [];
			const total = first?.TotalCount || 0;
			if (total <= items.length)
				return (items);
			const all = await genRequest(url(total));
			return (all?.Items || []);
		},
		staleTime: PROFESSIONS_STALE_TIME,
	});
}

export const toProfessionsMap = (contacts) =>
	new Map((contacts || []).map((u) => [getUserId(u), { WFY: u.WFY, WFU: u.WFU }]));

export async function fetchProfessions(QCL, genRequest, companyId) {
	const { queryKey, queryFn, staleTime } = professionsQuery(genRequest, companyId);
	return (toProfessionsMap(await QCL.fetchQuery(queryKey, queryFn, { staleTime })));
}

export const withProfessions = (user, professions) => {
	const known = professions.get(getUserId(user));
	return ({
		...user,
		WFY: user.WFY || known?.WFY || "",
		WFU: user.WFU || known?.WFU || "",
	});
};
